import { PagedResponse } from "../Models";
import { IGetCostCodeByIdEndpoint } from "./GetCostCodeByIdEndpoint";
export class CostCodeRepository implements ICostCodeRepository
{
    private getCostCodeByIdEndpoint: IGetCostCodeByIdEndpoint;

    constructor(
        getCostCodeByIdEndpoint: IGetCostCodeByIdEndpoint,
    )
    {
        this.getCostCodeByIdEndpoint = getCostCodeByIdEndpoint;
    }

    public getCostCodeById(costCodeId: string): Promise<ICostCode>
    {
        return this.getCostCodeByIdEndpoint.execute(costCodeId);
    }
}
export interface ICostCodeRepository 
{
    getCostCodeById(costCodeId: string): Promise<ICostCode>;
}

export interface ICostCode
{
    Cost_Code: string;
    Cost_Code_Description: string;
    Cost_Code_Id: string;
    Cost_Code_Type: number;
    Cost_Code_Source: string;
    EventTime: string;
}

export enum CostCodeSource
{
    Any = 'Any',
    SFTP = 'SFTP',
    API = 'API',
    Manual = 'Manual',
}

export enum CostCodeType
{
    Any = 'Any',
    StandardCostCode = 'IBSS Standard Cost Code',
    ClientCode = 'Client Code (WBS)',
    DepartmentCode = 'Department Code',
}
